import React from 'react';
import StyledText from 'src/common/refactoredComponents/styledText/StyledText';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import { useTranslation } from 'react-i18next';
import DropdownWithErrorText from './DropdownWithError';
import { useSelector } from 'react-redux';
import { DARK_GRAY_FONT_COLOR, DARK_NAVY_FONT_COLOR, FONT_FAMILY_DEMI, SEMANTIC_TEXT_SMALL_PX, SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';

const NtCheckboxDropdownWithErroText = ({
    checked,
    checkBoxClick,
    inventoryShipping,
    batchLocations,
    selectedBatchLocationTemplate,
    batchLocationTemplate,
    selectedLocation,
    handleLocationChange,
    nonTissueProduct,
    allocatedData,
    isShowCheckBox=false,
    isMessageDisplay=false,
    isShowLabelEmpty=false,
    isShowSetLocation=true,
    isShowDropDown=true,
}) => {
    const { t } = useTranslation();
    const shipDontShipSurgery = useSelector(
        (state) => state.loginReducer.shipDontShipSurgery
    );
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    return (
        <>
            {shipDontShipSurgery !== 'NOT_VISIBLE'  && isShowCheckBox && (
                <Checkbox 
                    checked={checked}
                    onCheckboxSelectionChange={checkBoxClick}
                    label={isShowLabelEmpty ? '' : t(
                        'scheduleSurgery.Shipping.ProductCard.DontShipSet'
                    )}
                    disabled={inventoryShipping}
                    margin={'0 6px 0 0'}
                    labelStyleObj={{
                        fontSize: SEMANTIC_TEXT_SMALL_PX,
                        fontFamily: FONT_FAMILY_DEMI,
                        color: DARK_NAVY_FONT_COLOR,
                    }}
                    id='surgery-shipping-Nt-CheckboxDropdopwnWithErroText'
                    background={'none'}
                    checkboxBorder={'1.5px solid #555555'}
                    alignItemDirection={'center'}
                    hoverEffect={'false'}
                    disableFocusEffect={'true'}
                />
            )}
            {checked ? (
                <>
                    {isShowSetLocation && isMessageDisplay && <StyledText
                        fontColor={DARK_GRAY_FONT_COLOR}
                        fontSize={SMALL_TEXT_PX}
                        fontFamily={FONT_FAMILY_DEMI}
                        margin="12px 0px 0px 0px"
                    >
                        {t('scheduleSurgery.Shipping.ProductCard.SetLocation')}
                    </StyledText>}
                    {isShowDropDown && <DropdownWithErrorText
                        AlertCircleOutline={AlertCircleOutline}
                        nonTissueProduct={nonTissueProduct}
                        batchLocations={batchLocations}
                        checked={checked}
                        allocatedData={allocatedData}
                        selectedBatchLocationTemplate={
                            selectedBatchLocationTemplate
                        }
                        batchLocationTemplate={batchLocationTemplate}
                        selectedLocation={selectedLocation}
                        handleLocationChange={handleLocationChange}
                    />}
                </>
            ) : (
                <></>
            )}
            {checked}
        </>
    );
};

export default NtCheckboxDropdownWithErroText;
